const doc = [({"label":"Nach einer Gemeinde suchen:", "placeholder":"Gemeindename"})];
module.exports = doc.length <= 1 ? doc[0] : doc;